export enum ErrorMessages {
  IDPIFRAME_INITIALIZATION_FAILED = 'idpiframe_initialization_failed',
  POPUP_CLOSED_BY_USER = 'popup_closed_by_user',
  TEMP_ERROR = 'temp_error',
}

export enum SignInErrorMessages {
  DEFAULT = 'Sorry, something went wrong!',
  INVALID_ROLE = 'User does not have Landing Direct Partner access.',
  TEMP_LOGIN = 'Use "test@mc.com" email and "magic" as password to login as test user',
}
